import { render, staticRenderFns } from "./VideoCustom.vue?vue&type=template&id=295a31e9&scoped=true&"
import script from "./VideoCustom.vue?vue&type=script&lang=js&"
export * from "./VideoCustom.vue?vue&type=script&lang=js&"
import style0 from "./VideoCustom.vue?vue&type=style&index=0&id=295a31e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a31e9",
  null
  
)

export default component.exports